import React, { createContext, useState, useEffect, useContext } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    // console.log('AuthProvider mounted, token:', token);
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchUser = async () => {
    // console.log('Fetching user...');
    try {
      const response = await authAPI.getCurrentUser();
      // console.log('User response:', response.data);
      if (response.data.success) {
        setUser(response.data.user);
        // console.log('User set:', response.data.user);
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      handleLogout();
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = () => {
    authAPI.googleLogin();
  };

  const handleAuthSuccess = (tokenFromUrl) => {
    // console.log('Auth success, token:', tokenFromUrl);
    localStorage.setItem('token', tokenFromUrl);
    setToken(tokenFromUrl);
  };

  const handleLogout = async () => {
    try {
      if (token) {
        await authAPI.logout();
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      setToken(null);
      setUser(null);
    }
  };

  const value = {
    user,
    token,
    loading,
    isAuthenticated: !!user,
    login: handleLogin,
    logout: handleLogout,
    handleAuthSuccess,
  };

  // console.log('AuthContext value:', value);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};